<div class="grid grid-cols-2 gap-1">
  @for (device of soilDeviceList$ | async; track device.id) {
    <app-device-reduced-dashboard-card [device]="device" />
  }

  @for (device of flowDeviceList$ | async; track device.id) {
    <app-device-reduced-dashboard-card [device]="device" />
  }
</div>

<!--mat-tab-group>
  <mat-tab label="Soil">
    <div class="grid grid-cols-2 gap-1">
      @for (device of soilDeviceList$ | async; track device.id) {
        <app-device-reduced-dashboard-card [device]="device" />
      }
    </div>
  </mat-tab>
  <mat-tab label="Flow">
    <div class="grid grid-cols-2 gap-1">
      @for (device of flowDeviceList$ | async; track device.id) {
        <app-device-reduced-dashboard-card [device]="device" />
      }
    </div>
  </mat-tab>
</mat-tab-group-->
